import { getDefaultFeatureFlags } from '../actions/getDefaultFeatureFlags';

const uberFlag = 'fwk-uberflag';
const consumerFlag = 'fwk-consumer';
const businessFlag = 'fwk-business';

export function checkUberFlight(): 0 | 1 {
    return getIntegrityFlights().includes(uberFlag) ? 1 : 0;
}

export function checkUserTypeFlight(isConsumer: boolean): 0 | 1 {
    const integrityFlights = getIntegrityFlights();
    return (isConsumer &&
        integrityFlights.includes(consumerFlag) &&
        !integrityFlights.includes(businessFlag)) ||
        (!isConsumer &&
            integrityFlights.includes(businessFlag) &&
            !integrityFlights.includes(consumerFlag))
        ? 1
        : 0;
}

let integrityFlags: string[] | undefined;
function getIntegrityFlights(): string[] {
    if (!integrityFlags) {
        integrityFlags = getDefaultFeatureFlags().filter(
            f => f === uberFlag || f === consumerFlag || f === businessFlag
        );
    }

    return integrityFlags;
}
